class SkeletonHTMLElement extends HTMLElement {
	constructor() {
		super();
	}

	checkPageContentLoaded(elementSelector) {
		const element = document.querySelector(elementSelector);
		waitForElement(elementSelector).then(() => {
			this.classList.add('hidden');
			element?.classList.remove('hidden');
		});
	}
}

class SkeletonCollection extends SkeletonHTMLElement {
	static CLASSES = {
		PRODUCT_GRID_WRAPPER: '.product-grid__wrapper',
	};
	constructor() {
		super();
	}
	connectedCallback() {
		this.checkPageContentLoaded(SkeletonCollection.CLASSES.PRODUCT_GRID_WRAPPER);
	}
}

class SkeletonProductGrid extends SkeletonHTMLElement {
	static CLASSES = {
		PRODUCT_SECTION: '.product',
	};
	constructor() {
		super();
	}
	connectedCallback() {
		this.checkPageContentLoaded(SkeletonProductGrid.CLASSES.PRODUCT_SECTION);
	}
}

customElements.define('skeleton-collection', SkeletonCollection);
customElements.define('skeleton-product-grid', SkeletonProductGrid);
